<template>
  <div class="npubsub-portal">
    <div class="background pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">{{$t('dataRide.banner1.title')}}</h1>
            <p class="text" v-html="$t('dataRide.banner1.text')"></p>
          </div>
          <div class="banner-1">
            <img v-lazy="'/static/img/home/dataRide.png'">
          </div>
        </div>
      </div>
    </div>
    <div class="background pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="banner-3 column">
            <div class="flex justify-between mt-50" style="height: 160px;">
              <div class="col-4 icon-title-item">
                <font-awesome-icon :icon="['fas','comments']" size="5x" style="color:#1791f2;"/>
                <span class="text">{{$t('dataRide.banner2.icon1')}}</span>
              </div>
              <div class="col-4 icon-title-item">
                <img v-lazy="'/static/img/npubsub/npubsub-icon-1.png'" style="width:80px">
                <span class="text">{{$t('dataRide.banner2.icon2')}}</span>
              </div>
              <div class="col-4 icon-title-item">
                <img v-lazy="'/static/img/npubsub/npubsub-icon-2.png'" style="width:80px">
                <span class="text">{{$t('dataRide.banner2.icon3')}}</span>
              </div>
            </div>
            <div class="flex justify-between" style="height: 160px;">
              <div class="col-4 icon-title-item">
                <a href="/dataride/support/"><font-awesome-icon :icon="['fas','headset']" size="5x" style=" color:green;"/></a>
                <a href="/dataride/support/" class="link text">{{$t('dataRide.banner2.icon4')}}</a>
              </div>
              <div class="col-4 icon-title-item">
                <font-awesome-icon :icon="['fas','wrench']" size="5x" style=" color:#3752C2;"/>
                <span class="text">{{$t('dataRide.banner2.icon5')}}</span>
              </div>
              <div class="col-4 icon-title-item">
                <img v-lazy="'/static/img/npubsub/npubsub-icon-3.png'" style="width:72px">
                <span class="text">{{$t('dataRide.banner2.icon6')}}</span>
              </div>
            </div>
          </div>
          <div class="details-1">
            <h1 class="title">{{$t('dataRide.banner2.title')}}</h1>
            <h2 class="subheader">{{$t('dataRide.banner2.subTitle')}}</h2>
            <p class="text" v-html="$t('dataRide.banner2.text')"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="common-title">{{$t("dataRide.banner3.title")}}</div>
      <div class="nkn-container">
        <div class="row flex">
          <div class="flex column align-center col-xs-12 col-sm-12 col-md-4">
            <div class="banner-1 flex" style="width:100%;flex-grow:0;height: 300px;">
              <div v-html="code" v-highlight style="width:100%;height:250px;"></div>
            </div>
            <div class="details-1">
              <h1 class="title">{{$t("dataRide.banner3.title1")}}</h1>
              <p class="text" v-html="$t('dataRide.banner3.text1')"></p>
            </div>
          </div>
          <div class="flex column align-center col-xs-12 col-sm-12 col-md-4">
            <div class="banner-1 flex" style="height:300px;">
              <img v-lazy="'/static/img/npubsub/npubsub-banner-3.png'" style="height:200px;width:auto;max-width:100%;">
            </div>
            <div class="details-1">
              <h1 class="title">{{$t("dataRide.banner3.title2")}}</h1>
              <p class="text" v-html="$t('dataRide.banner3.text2')"></p>
            </div>
          </div>
          <div class="flex column align-center col-xs-12 col-sm-12 col-md-4">
            <div class="banner-1 flex" style="width:100%;height:300px;">
              <img v-lazy="'/static/img/npubsub/npubsub-icon-4.png'" style="height:200px;width:auto;">
            </div>
            <div class="details-1">
              <h1 class="title">{{$t("dataRide.banner3.title3")}}</h1>
              <p class="text" v-html="$t('dataRide.banner3.text3')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="common-title">{{$t("dataRide.banner4.title")}}</div>
      <div class="nkn-container">
        <div class="row flex">
          <div class="flex column align-center col-xs-12 col-sm-12 col-md-4">
            <div class="banner-1 flex" style="height:300px;">
              <img v-lazy="'/static/img/npubsub/npubsub-banner-6.png'" style="height:200px;width:auto;max-width:100%;">
            </div>
            <div class="details-1">
              <h1 class="title">{{$t("dataRide.banner4.title1")}}</h1>
              <p class="text" v-html="$t('dataRide.banner4.text1')"></p>
            </div>
          </div>
          <div class="flex column align-center col-xs-12 col-sm-12 col-md-4">
            <div class="banner-1 flex" style="height:300px;">
              <img v-lazy="'/static/img/npubsub/npubsub-banner-2.png'" style="height:200px;width:auto;max-width:100%;">
            </div>
            <div class="details-1">
              <h1 class="title">{{$t("dataRide.banner4.title2")}}</h1>
              <p class="text" v-html="$t('dataRide.banner4.text2')"></p>
            </div>
          </div>
          <div class="flex column align-center col-xs-12 col-sm-12 col-md-4">
            <div class="banner-1 flex" style="width:100%;height:300px;">
              <img v-lazy="'/static/img/npubsub/npubsub-banner-7.png'" style="height:200px;width:auto;max-width:100%;">
            </div>
            <div class="details-1">
              <h1 class="title">{{$t("dataRide.banner4.title3")}}</h1>
              <p class="text" v-html="$t('dataRide.banner4.text3')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="common-title">{{$t("dataRide.banner5.title")}}</div>
      <div class="nkn-container">
        <div class="flex mt-50">
          <div class="flex justify-around align-center" style="width:100%;height:100%;">
            <div class="column icon-title-item" style="height: 180px;justify-content: space-between;">
              <div style="display: flex;height:100%;flex-direction: column;justify-content: center;">
                <a :href="$t('dataRide.banner5.url1')" target="_blank">
              <img v-lazy="'/static/img/npubsub/NKN_D-chat_LOGO-02-gray-blue.png'" style="width:auto;height:6rem;">
                </a>
              </div>
              <a class="link" :href="$t('dataRide.banner5.url1')" target="_blank">{{$t("dataRide.banner5.title1")}}</a>
            </div>
            <div class="column icon-title-item" style="height: 180px;justify-content: space-between;">
              <div style="display: flex;height:100%;flex-direction: column;justify-content: center;">
                <a :href="$t('dataRide.banner5.url2')" target="_blank">
                  <img v-lazy="'/static/img/developer/dApp/nMobile.png'" style="width:auto;height:5rem;">
                </a>
              </div>
              <a class="link" :href="$t('dataRide.banner5.url2')" target="_blank">
              {{$t("dataRide.banner5.title2")}}
              </a>
            </div>
            <div class="column icon-title-item" style="height: 180px;justify-content: space-between;">
              <div style="display: flex;height:100%;flex-direction: column;justify-content: center;">
                <a :href="$t('dataRide.banner5.url3')" target="_blank">
                <img v-lazy="'/static/img/npubsub/npubsub-banner-8.png'" style="width:auto;height:3rem;">
                </a>
              </div>
              <a class="link" :href="$t('dataRide.banner5.url3')" target="_blank">{{$t("dataRide.banner5.title3")}}</a>
            </div>
            <!--<div class="column icon-title-item" style="height: 180px;justify-content: space-between;">
              <div style="display: flex;height:100%;flex-direction: column;justify-content: center;">
                <img v-lazy="'/static/img/npubsub/npubsub-banner-9.png'" style="width:auto;height:4rem;">
              </div>
              <span>{{$t("dataRide.banner5.title4")}}</span>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">

          <div class="details-1">
            <h1 class="title"><a class="link" href="https://dataRide.nkn.org" target="_blank">{{$t("dataRide.banner6.title")}}</a></h1>
            <p class="text">{{$t("dataRide.banner6.text")}}</p>
            <a class="link" href="https://dataRide.nkn.org" target="_blank">https://dataRide.nkn.org</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
    components: {},
    computed: {
      ...mapGetters({
        lang: 'getLang'
      })
    },
    data() {
      return {
        code: `<pre style="height:100%"><code style="height:100%" class="language-javascript">//Install nkn-client
const nkn = require('nkn-multiclient');

//Creates a client with a generated key pair
const client = nkn();

//Listen for connection establish
client.on('connect', () => {
  console.log('Connection opened.');
});
</code></pre>`
      }
    },
    metaInfo() {
      if (this.$i18n.locale === 'zh') {
        return {
          title: 'dataRide',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          attribute: '',
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'dataRide。'
            }
          ]
        }
      } else {
        return {
          title: 'dataRide',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'dataRide.'
            }
          ]
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  .npubsub-portal {
    position: relative;
  }

  .nkn-container {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .details-1 {
    max-width: 400px;
    width: 100%;
    flex-shrink: 0;
    align-self: center;

    .title {
      font-size: 1.2rem;
      color: #0096FF;
      font-weight: 500;
    }

    .subheader {
      font-size: 0.9rem;
      color: #0096FF;
      font-weight: 500;
    }

    .text {
      font-size: 0.75rem;
      color: #24397D;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 1rem;
      margin-top: .75rem;
    }
  }

  .details-2 {
    width: 50%;
    flex-shrink: 0;
    align-self: center;
    @media screen and (max-width: 768px) {
      width: 100%;
    }

    .title {
      font-size: 1.2rem;
      color: #0096FF;
      font-weight: 500;
    }

    .subheader {
      font-size: 0.9rem;
      color: #0096FF;
      font-weight: 500;
    }

    .text {
      font-size: 0.75rem;
      color: #24397D;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 1rem;
      margin-top: .75rem;
    }
  }

  .banner-1 {
    flex-shrink: 1;
    max-width: 500px;

    img {
      width: 100%;
    }
  }

  .banner-2 {
    display: flex;
    max-width: 600px;
    width: 100%;
    align-items: center;
    justify-content: space-around;

    div {
      flex-shrink: 1;
      flex-grow: 0;
      margin-right: 10px;

      img {
        display: block;
        height: 100%;
        width: 100%;

      }
    }
  }

  .banner-3 {
    display: flex;
    max-width: 600px;
    width: 100%;
    align-items: center;
    justify-content: space-around;
  }

  .icon-title-item {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    width: 150px;
    .text{
      margin-top: auto;
    }
  }

  .aqi-logo {
    width: auto;
    height: 70px;
  }

  .mp-logo {
    width: auto;
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/NPubSubPortal.vue